/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import axios from 'axios';

const hostUrl = "";

export default {

    signup: (organisationHeadDetails, organisationDetails) => {
        return axios.post(hostUrl + '/api/user/organisation/signup', { organisationHeadDetails, organisationDetails })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getApprovalStatus: () => {
        return axios.get(hostUrl + '/api/organisation/approvalStatus')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get organisation head profile image
    getOrganisationProfileImageAndEmail: () => {
        return axios.get(hostUrl + '/api/organisation/profileImageAndEmail')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    postRazorpayOrganisationSubscription: (razorpaySubscriptionPlanId, razorpaySubscriptionNotes) => {
        return axios.post(hostUrl + '/api/organisation/razorpay/subscription', { razorpaySubscriptionPlanId, razorpaySubscriptionNotes })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            throw err.response.data;
        });
    },

    postOrganisationSubscription: (organisationSubscriptionPlanId, razorpaySubscriptionId) => {
        return axios.post(hostUrl + '/api/organisation/subscription', { organisationSubscriptionPlanId, razorpaySubscriptionId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getActiveOrganisationSubsription: () => {
        return axios.get(hostUrl + '/api/organisation/subscription/active')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getOrganisationSubcriptions: () => {
        return axios.get(hostUrl + '/api/organisation/subscriptions')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getOrganisationSubscriptionPlan: (id) => {
        return axios.get(hostUrl + '/api/organisation/subscriptionPlan', { params: { id: id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getOrganisationSubscriptionPlans: () => {
        return axios.get(hostUrl + '/api/organisation/subscriptionPlans')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    }


}